import {
  Tooltip as ChakraTooltip,
  PlacementWithLogical,
} from "@chakra-ui/react";
import { InfoIcon } from "@phosphor-icons/react";
import { ReactNode, useState } from "react";

type TooltipProps = {
  label: ReactNode;
  closeDelay?: number;
  placement?: PlacementWithLogical;
};
export const Tooltip = ({ label, closeDelay, placement }: TooltipProps) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <ChakraTooltip
      label={label}
      isOpen={isVisible}
      closeDelay={closeDelay ? closeDelay : 2000}
      onClose={() => setIsVisible(false)}
      pointerEvents="all"
      color="textSecondary"
      fontSize="12px"
      bg="backgroundCard"
      p="8px"
      borderRadius="8px"
      placement={placement ? placement : "auto"}
    >
      <span>
        <InfoIcon
          onMouseEnter={() => setIsVisible(true)}
          onClick={() => setIsVisible(true)}
          color="#1A1A1A"
        />
      </span>
    </ChakraTooltip>
  );
};

export default Tooltip;
